import { flatten, intersection, uniq } from "ramda";
import { ATTRIBUTES } from "../../constants/constants";
import { configStore } from "../config/config";

export function getOtherIds(ids, currentName) {
  return uniq(
    flatten(
      ids
        .filter((id) => id.name !== currentName)
        .reduce((array, id) => {
          if (array.length) {
            array = intersection(id.ids, array);
          } else {
            return id.ids;
          }
          return array;
        }, [])
    )
  );
}

export const getSelectedIds = ({ features }) => {
  const ids = ATTRIBUTES[configStore.name].map((name) => {
    return {
      name,
      ids: uniq(
        flatten(
          features
            .filter(
              (feature) =>
                feature.fieldName === name &&
                feature.selected &&
                !feature.disabled
            )
            .map((feature) => [...feature.layerIds])
        )
      ),
    };
  });
  return ids;
};

export const computeIds = ({ visibleIds, selectedIds }) => {
  const ids = visibleIds.length
    ? ATTRIBUTES[configStore.name].map((name) => {
        const sid = selectedIds.length
          ? selectedIds.find((id) => id.name === name)
          : { ids: [] };
        const filteredIds = sid.ids.length
          ? intersection(sid.ids, visibleIds)
          : visibleIds;
        return {
          name: name,
          ids: filteredIds,
        };
      })
    : selectedIds.map((sid) => {
        const filteredIds = visibleIds.length
          ? intersection(visibleIds, sid.ids)
          : sid.ids;
        return {
          name: sid.name,
          ids: filteredIds,
        };
      });
  return ids;
};
